export const NAME = 'Landon Dyken';

export const CV_URL = 'https://drive.google.com/file/d/1Jrk69NGqaLh3WmHiGV2YlE-Cmr0Tlptc/view?usp=sharing';

export const SCHOLAR_URL = 'https://scholar.google.com/citations?user=LVW51pcnYFYC&hl=en&oi=ao';

// Author profile shown in the sidebar.
export const PROFILE = {
    location: 'Chicago, IL',
    employer: 'University of Illinois Chicago',
};

export const BIO = [
    'Welcome! I’m Landon, a PhD candidate and graduate research assistant at the University of Illinois Chicago, currently pursuing a degree in Computer Science under Dr. Sidharth Kumar. My focus is on scientific visualization, specifically using applied ML, web-based tools and GPU-accelerated systems.',
    'Before beginning my PhD, I received a dual B.S. in Computer Science and Mathematics from the University of Alabama at Birmingham in 2022, and an M.S. in Computer Science from UAB in 2023. Please feel free to connect with me through any of the platforms listed here!',
];

export const CONTACTS = {
    email: 'mailto:ldyke@uic.edu',
    scholar: SCHOLAR_URL,
    github: 'https://github.com/ldyken53',
    linkedin: 'https://www.linkedin.com/in/landon-dyken-a7b086222/',
};
